const QuoteSection = () => {
  return (
    <section className="py-12 bg-secondary/50 [&_*]:!transition-none" aria-labelledby="quote-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <blockquote className="text-xl md:text-2xl lg:text-3xl font-bold italic text-center max-w-4xl mx-auto">
          <span className="text-primary">"</span>Limitation is just a Word, Impossible is Fiction<br />
          Rules are to be Broken as we are capable of far more!<span className="text-primary">"</span>
        </blockquote>
      </div>
    </section>
  );
};

export default QuoteSection;
